import type { ReceiptTemplate } from '../schema';

export const facebookMarketplaceTemplate: ReceiptTemplate = {
  id: 'facebook-marketplace',
  name: 'Facebook Marketplace Receipt',
  brand: 'FACEBOOK MARKETPLACE',
  description: 'Facebook Marketplace purchase receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'fbm-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'FACEBOOK MARKETPLACE',
        businessNameFontSize: 14,
        addressLines: ['PURCHASE RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'fbm-order',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'FBM-847291034' },
          { id: 'seller', label: 'Seller:', value: 'Mike Wazowski' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'buyer', label: 'Buyer:', value: 'John Doe' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'fbm-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [{ id: '1', name: 'VINTAGE COFFEE TABLE', quantity: '1', price: '75.00', sku: '' }],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'fbm-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'item', label: 'ITEM', value: '75.00', isBold: false, isLarge: false },
          { id: 'shipping', label: 'SHIPPING', value: '12.99', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '87.99', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'fbm-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'META PAY', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'fbm-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'BUYER PROTECTION INCLUDED\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

